/* =========================================
   IGS MEDIA — CUSTOM.JS (STABILE)
   SOLO CHIPS / PROMO / COLORI / NOTE
========================================= */
(function () {
  const BADGE_TEXT = "★ PIÙ SCELTO DAGLI ATLETI";
  const BADGE_CLASS = "igs-badge";
  const NOTE_CLASS  = "igs-chip-note";
  const DOT_CLASS   = "igs-color-dot";

  const colorMap = [
    { keys: ["gold", "oro", "golden", "limited edition", "limited", "edition"], hex: "#d4af37", light: true },
    { keys: ["azzurro", "celeste", "sky", "light blue", "baby blue"], hex: "#35b6ff", light: true },
    { keys: ["rosa", "pink", "fucsia", "fuchsia"], hex: "#ff4fa3" },
    { keys: ["arancione", "arancio", "orange", "arancione fluo", "fluo orange"], hex: "#ff6a00" },
    { keys: ["nero", "black"], hex: "#111111" },
    { keys: ["bianco", "white"], hex: "#ffffff", light: true },
    { keys: ["giallo", "yellow"], hex: "#ffd400", light: true },
    { keys: ["rosso", "red"], hex: "#e10600" },
    { keys: ["verde", "green"], hex: "#0aa84f" },
    { keys: ["blu", "blue", "navy"], hex: "#0047ff" },
    { keys: ["viola", "purple"], hex: "#7b2cff" },
    { keys: ["grigio", "grey", "gray"], hex: "#8a8a8a" }
  ];

  function norm(s){ return String(s||"").toLowerCase().replace(/\s+/g," ").trim(); }
  function isPromoFotoVideo(text){
    const t = norm(text);
    return (t.includes("promo") || t.includes("offerta")) && t.includes("foto") && t.includes("video");
  }
  function isAllInclusive(text){
    const t = norm(text);
    return t.includes("all inclusive") || (t.includes("all") && t.includes("inclusive"));
  }
  function findColor(text){
    const t = norm(text);
    for (const c of colorMap) if (c.keys.some(k => t.includes(k))) return c;
    return null;
  }

  function getProductRoot(){
    return (
      document.querySelector('[id^="ProductSection-"]') ||
      document.querySelector('[data-section-type="product-template"]') ||
      document.querySelector("main") ||
      document.body
    );
  }

  function getChips(root){
    return root.querySelectorAll(
      ".variant-input-wrap label, .product-form__input label, fieldset label, .variant-input-wrap button, .product-form__input button, [role='radio']"
    );
  }

  function ensurePromoBadge(chip){
    if (!isPromoFotoVideo(chip.textContent)) return;
    if (chip.querySelector("." + BADGE_CLASS)) return;

    chip.style.position = "relative";
    chip.style.overflow = "visible";
    chip.style.paddingTop = "18px";

    const b = document.createElement("span");
    b.className = BADGE_CLASS;
    b.textContent = BADGE_TEXT;
    chip.appendChild(b);
  }

  function ensureAllInclusiveNote(chip){
    if (!isAllInclusive(chip.textContent)) return;

    const next = chip.nextElementSibling;
    if (next && next.classList && next.classList.contains(NOTE_CLASS)) return;

    const note = document.createElement("div");
    note.className = NOTE_CLASS;
    note.textContent = "Massimo risparmio";
    chip.insertAdjacentElement("afterend", note);

    const show = () => chip.classList.add("igs-note-show");
    const hide = () => chip.classList.remove("igs-note-show");

    chip.addEventListener("mouseenter", show);
    chip.addEventListener("mouseleave", hide);
    chip.addEventListener("focus", show, true);
    chip.addEventListener("blur", hide, true);
    chip.addEventListener("touchstart", () => chip.classList.toggle("igs-note-show"), { passive: true });
  }

  function ensureColorDotAndMark(chip, c){
    chip.querySelectorAll("." + DOT_CLASS).forEach(d => d.remove());

    chip.style.display = "flex";
    chip.style.alignItems = "center";
    chip.style.gap = "8px";

    const dot = document.createElement("span");
    dot.className = DOT_CLASS;
    dot.style.background = c.hex;
    if (c.light) dot.style.border = "2px solid #ccc";
    chip.prepend(dot);

    chip.classList.add("igs-has-color");
    chip.style.setProperty("--igsColor", c.hex);
    chip.classList.toggle("igs-text-dark", !!c.light);
    chip.classList.toggle("igs-text-light", !c.light);
  }

  function updateSelectedColorChips(root){
    root.querySelectorAll(".igs-has-color.igs-selected").forEach(el => el.classList.remove("igs-selected"));

    const checked = root.querySelectorAll(
      ".variant-input-wrap input[type='radio']:checked + label, " +
      ".product-form__input input[type='radio']:checked + label, " +
      "fieldset input[type='radio']:checked + label, " +
      ".variant-input-wrap input[type='radio']:checked + button, " +
      ".product-form__input input[type='radio']:checked + button"
    );

    checked.forEach((chip) => {
      if (chip.classList.contains("igs-has-color")) chip.classList.add("igs-selected");
    });
  }

  function applyAllOnce(){
    const root = getProductRoot();
    if (!root) return;

    const chips = getChips(root);
    if (!chips.length) return;

    chips.forEach((chip) => {
      ensurePromoBadge(chip);
      ensureAllInclusiveNote(chip);
      const c = findColor(chip.textContent);
      if (c) ensureColorDotAndMark(chip, c);
    });

    updateSelectedColorChips(root);
  }

  let scheduled = false;
  function scheduleApply(){
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      applyAllOnce();
    }, 120);
  }

  document.addEventListener("DOMContentLoaded", () => {
    applyAllOnce();
    document.addEventListener("change", () => scheduleApply(), true);

    const root = getProductRoot();
    if (root && window.MutationObserver) {
      const obs = new MutationObserver(() => scheduleApply());
      obs.observe(root, { childList: true, subtree: true });
    }
  });

  window.addEventListener("load", () => applyAllOnce());
})();
/* ======================================
   IGS — Thumbnail sync stile Nike
====================================== */

(function(){

  function initNikeGallery(){

    const slider =
      document.querySelector('.product-image-main .slick-slider');

    const thumbs =
      document.querySelectorAll(
        '.product-thumbnails img, .product__thumbnails img'
      );

    if(!slider || !window.jQuery) return;

    thumbs.forEach((thumb, index)=>{

      thumb.addEventListener('click', function(e){
        e.preventDefault();

        // cambia slide grande
        window.jQuery(slider).slick('slickGoTo', index);

      });

    });

  }

  document.addEventListener('DOMContentLoaded', initNikeGallery);
  window.addEventListener('load', initNikeGallery);

})();
/* =========================================
   IGS — Mobile: Prezzo + confronto sempre sopra ATC (e nascondi duplicati)
   Streamline-safe
========================================= */
(function () {
  const MOBILE_MAX = 768;
  const isMobile = () => window.matchMedia && window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;

  function getRoot() {
    return (
      document.querySelector("[data-section-type='product-template']") ||
      document.querySelector(".product-section") ||
      document.querySelector("[id^='ProductSection-']") ||
      document.querySelector("main") ||
      document.body
    );
  }

  function findATC(root) {
    return (
      root.querySelector('form[action*="/cart/add"] button[name="add"]') ||
      root.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      root.querySelector('button[name="add"]') ||
      null
    );
  }

  function isInsideGallery(el) {
    return !!el.closest(".product-image-main, .product__photos, .product-slideshow, [data-product-slideshow], .product__media");
  }

  function findPriceContainers(scope) {
    return Array.from(
      scope.querySelectorAll("[data-price-wrapper], .price__container, .price, .product__price, .product-single__price")
    );
  }

  function movePriceAboveATC() {
    if (!isMobile()) return;

    const root = getRoot();
    const atc = findATC(root);
    if (!root || !atc) return;

    const form = atc.closest("form") || null;
    if (!form) return;

    // 1) trovo il container prezzo “giusto” dentro il FORM
    const inForm = findPriceContainers(form)
      .filter(el => (el.innerText || "").trim().length > 0)
      .sort((a, b) => b.innerText.length - a.innerText.length)[0];

    if (!inForm) return;

    // 2) creo slot DENTRO il form e lo metto subito prima del bottone
    let slot = form.querySelector(".igs-price-slot");
    if (!slot) {
      slot = document.createElement("div");
      slot.className = "igs-price-slot";
    }
    atc.insertAdjacentElement("beforebegin", slot);

    // 3) sposto SEMPRE dentro slot (se Streamline lo rigenera, noi lo rimettiamo)
    if (!slot.contains(inForm)) slot.appendChild(inForm);

    // 4) nascondo eventuali duplicati fuori dal form (tipicamente sotto foto)
    const all = findPriceContainers(root);
    all.forEach(el => {
      if (el === inForm) return;
      // se è fuori dal form o dentro gallery, lo nascondo su mobile
      if (!form.contains(el) || isInsideGallery(el)) el.classList.add("igs-hide-price-dup");
    });
  }

  document.addEventListener("DOMContentLoaded", movePriceAboveATC);
  window.addEventListener("load", movePriceAboveATC);
  document.addEventListener("change", () => setTimeout(movePriceAboveATC, 50), true);

  // Observer leggero ma efficace (Streamline rimpiazza nodi)
  const obs = new MutationObserver(() => movePriceAboveATC());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
document.addEventListener('DOMContentLoaded', () => {
  const productSections = document.querySelectorAll('[data-product-id], .product-section');
  if (!productSections.length) return;

  productSections.forEach((section) => {
    const form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const variantSelect = form.querySelector('select[name="id"]');
    if (!variantSelect) return;

    // Prende il JSON prodotto più vicino alla sezione (Streamline)
    const jsonEl = section.querySelector('script[type="application/json"]');
    if (!jsonEl) return;

    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!product?.variants?.length) return;

    section.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-media-id], [data-product-single-thumbnail]');
      if (!thumb) return;

      let mediaId = thumb.getAttribute('data-media-id') || '';
      const m = String(mediaId).match(/(\d+)\s*$/);
      if (m) mediaId = m[1];
      if (!mediaId) return;

      const v = product.variants.find(x => String(x.featured_media?.id) === String(mediaId));
      if (!v) return;

      if (variantSelect.value !== String(v.id)) {
        variantSelect.value = String(v.id);
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});